var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35782 3.8803C5.3576 4.3223 5.1805 4.74611 4.86548 5.0585C4.55047 5.37089 4.12334 5.54626 3.67807 5.54604C3.2328 5.54582 2.80585 5.37002 2.49115 5.05732C2.17645 4.74462 1.99978 4.32063 2 3.87863C2.00022 3.43663 2.17732 3.01282 2.49233 2.70043C2.80735 2.38804 3.23447 2.21267 3.67975 2.21289C4.12502 2.21311 4.55197 2.38891 4.86667 2.70161C5.18137 3.01431 5.35804 3.4383 5.35782 3.8803ZM5.40819 6.78014H2.05037V17.2129H5.40819V6.78014ZM10.7135 6.78014H7.37251V17.2129H10.68V11.7382C10.68 8.68836 14.6842 8.40505 14.6842 11.7382V17.2129H18V10.6049C18 5.46354 12.0735 5.6552 10.68 8.18006L10.7135 6.78014Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.f6e2483f821a8f2342e3f733b81f1a5a.svg";
export { ForwardRef as ReactComponent };